import React from 'react';
import { useLocation } from 'react-router-dom';
import { PermissionRoute } from './PermissionRoute';
import { getRoutePermissions } from '../../config/routePermissions';

interface ProtectedRouteProps {
    children: React.ReactNode;
    path?: string; // Optional: can be provided or will use current location
}

/**
 * Automatically applies permission checking based on the centralized route configuration
 * This component looks up the current route and applies the appropriate permission checks
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, path }) => {
    const location = useLocation();
    const routePath = path || location.pathname;
    
    // Get permission configuration for this route
    const routeConfig = getRoutePermissions(routePath);
    
    // If no specific permissions are required, just render the children
    if (!routeConfig?.requiredPermissions || routeConfig.requiredPermissions.length === 0) {
        return <>{children}</>;
    }
    
    // Apply permission checking
    return (
        <PermissionRoute
            requiredPermissions={routeConfig.requiredPermissions}
            requireAny={routeConfig.requireAny}
            fallbackPath="/dashboard"
        >
            {children}
        </PermissionRoute>
    );
};
